import { render, staticRenderFns } from "./ArtisanTabs.vue?vue&type=template&id=5840b2cc"
import script from "./ArtisanTabs.vue?vue&type=script&lang=js"
export * from "./ArtisanTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports